import { useTranslation } from 'react-i18next';

import { AddLine, Button, Col, Form, Item, MinusCircleIcon, NumberInput, Row, Select, Title } from 'ui';

type P = {
  disabled?: boolean;
  name: string;
};

type ReminderInterval = 1 | 1440 | 60;

const ActivityReminders = ({ disabled, name }: P) => {
  const { t } = useTranslation();

  const getReminderLabel = ({ type }: { type: ReminderInterval }): string => {
    switch (type) {
      case 1:
        return t('Minutes');
      case 1440:
        return t('Days');
      case 60:
        return t('Hours');
    }
  };

  return (
    <Form.List name={name}>
      {(fields, { add, remove }) => (
        <>
          {fields.map((field) => (
            // eslint-disable-next-line no-restricted-syntax -- TODO: fix later
            <Form.Item className="activity-reminders__item" key={field.key} required={false}>
              <Row gutter="ms">
                <Col span={6}>
                  {/* eslint-disable-next-line no-restricted-syntax -- TODO: fix later */}
                  <Form.Item dependencies={[[name, field.name, 'type']]} noStyle>
                    {({ getFieldValue }) => {
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
                      const typeValue = getFieldValue([name, field.name, 'type']) ?? 1;

                      return (
                        <NumberInput
                          input={{
                            disabled,
                            min: 0,
                          }}
                          item={{
                            ...field,
                            hideLabel: true,
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
                            label: getReminderLabel({ type: typeValue }),
                            name: [field.name, 'minutes'],
                            rules: [{ required: true }],
                          }}
                        />
                      );
                    }}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Item hideLabel label="Type" name={[field.name, 'type']} rules={[{ required: true }]}>
                    <Select<ReminderInterval>
                      disabled={disabled}
                      options={[
                        {
                          label: t('Minutes'),
                          value: 1,
                        },
                        {
                          label: t('Hours'),
                          value: 60,
                        },
                        {
                          label: t('Days'),
                          value: 1440,
                        },
                      ]}
                    />
                  </Item>
                </Col>
                {!disabled && (
                  <Col className="delete-button-wrapper" span={2}>
                    <Button
                      icon={<MinusCircleIcon className="dynamic-delete-button" />}
                      onClick={() => {
                        remove(field.name);
                      }}
                      size="large"
                      type="text"
                    />
                  </Col>
                )}
              </Row>
            </Form.Item>
          ))}
          {!disabled && (
            // eslint-disable-next-line no-restricted-syntax -- TODO: fix later
            <Form.Item style={{ marginTop: 10 }}>
              <Button
                icon={<AddLine />}
                onClick={() => {
                  add();
                }}
                size="large"
                type="secondary"
              >
                Add new reminder
              </Button>
            </Form.Item>
          )}
          {disabled && fields.length === 0 ? (
            <Title level={5} marginBottom>
              No reminders were created for this activity
            </Title>
          ) : null}
        </>
      )}
    </Form.List>
  );
};

export default ActivityReminders;
